import React from "react";

const ShowToastContext = React.createContext();
const EmailContext = React.createContext();

export { ShowToastContext, EmailContext };
